export const humanize = (input: string) => input.charAt(0).toUpperCase() + input.slice(1).replace(/([A-Z])/g, ' $1').replace(/(_)/g, ' ').trim()